// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/purchase_limits/style.css
// module id = 1987
// module chunks = 0